
import Vue from 'vue';
import { Modal, Button } from '@descomplica/vue-components';
import { StudyPlanningModel } from '@/models/studyPlanning/StudyPlanningModel';
import { OVERDUE_STUDENT_IMAGE_URL } from '@/helpers/postgradStudyPlanning/constants';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

export default Vue.extend({
  components: {
    Modal,
    Button,
  },
  props: {
    studyPlanning: {
      type: StudyPlanningModel,
      default: null,
    },
  },
  data() {
    return {
      studentImage: OVERDUE_STUDENT_IMAGE_URL,
      showWarningModal: this.studyPlanning?.shouldShowWarningMessage || false,
    };
  },
  mounted() {
    Analytics.trackEvent(EVENT_LABELS.modalViewed, {
      in_overdue_user_warning_modal: true,
    });
  },
  methods: {
    closeWarningModal() {
      this.studyPlanning?.dismissWarningMessage();
      this.showWarningModal = false;
    },
    onCloseModal() {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        in_overdue_user_warning_modal: true,
        overdue_user_warning_modal_action: 'close',
      });
      this.closeWarningModal();
    },
    onCancelButton() {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        in_overdue_user_warning_modal: true,
        overdue_user_warning_modal_action: 'cancel',
      });
      this.closeWarningModal();
    },
    openStudyPlanningConfigModal() {
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        in_overdue_user_warning_modal: true,
        overdue_user_warning_modal_action: 'update',
      });
      this.closeWarningModal();
      this.$emit('openStudyPlanningConfigModal');
    },
  },
});
